<template>
  <div>
    <Breadcrumbs main="" title="transport.header" />
    <b-container fluid>
      <div>
        <h2 class="mb-1 mt-4 f-w-600">{{ $t('transport.transRequestList') }}</h2>
        <div class="row justify-content-start ml-2">
            <feather 
                @click="refresh" 
                class="text-primary" 
                type="refresh-cw"  
                size="25" 
                v-b-popover.hover.top="$t('approvedTrans.refreshTaskListMsg')">
            </feather>  
              <span class="texrt-dark mx-2"> {{ $t('approvedTrans.asOf') }}</span>
              <span class="text-primary"> {{ asOf }} </span>   
          </div>
        <b-table
          sticky-header
          head-variant="light"
          table-variant="info"
          show-empty
          sort-icon-left
          stacked="md"
          :sort-by.sync="sortByReqr"
          :sort-desc.sync="sortDescReqr"
          :items="itemsReqr"
          :fields="fieldsReqr"
          :current-page="currentPageReqr"
          :per-page="perPageReqr"
        >
          <template #cell(addressReqr)="row" >
              <b-button  size="sm"  v-b-popover.hover.top="row.item.contReqrAddress" variant="outline-info">
                  {{ $t('matchTx.reqr') }}
              </b-button>
          </template>
          <template #cell(addressRels)="row" >
              <b-button  size="sm" v-b-popover.hover.top="row.item.contRelsAddress" variant="outline-info">
                  {{ $t('matchTx.rels') }}
              </b-button>
          </template>
          <template #cell(contImageReqr)="row" >
            <b-button  size="sm" @click="openModalImageReqr(row.item, row.index, $event.target )" class="mb-1">
                {{ row.item.contNo }}
            </b-button>
          </template>
          <template #cell(actTrans)="row" >
            <b-button v-show="row.item.transStatus == 'waitAccept'" size="sm" variant="success" @click="actTransAccept(row.item)" class="mb-1">
              {{ $t('matchTx.accept') }}
            </b-button>
            <b-button v-show="row.item.transStatus == 'waitAccept'"  size="sm" variant="danger" @click="actTransReject(row.item)" class="mb-1">
              {{ $t('matchTx.reject') }}
            </b-button>
          </template>
          <template #empty>
              <h5>{{ $t('reuse.noRecord') }}</h5>
          </template>
        </b-table>
        <b-row>
          <div class="row col-sm-8 ">
            <b-col class="my-1 ml-3">
              <b-pagination
                v-model="currentPageReqr"
                :total-rows="totalRowsReqr"
                :per-page="perPageReqr"
                align="fill"
                class="my-0"
              ></b-pagination>
            </b-col>   
            <b-col sm="3" md="6" class="my-1">
              <b-form-group
                :label= "$t('require.perPage')"
                label-for="per-page-select"
                label-cols-sm="6"
                label-cols-md="4"
                label-cols-lg="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-form-select
                  id="per-page-select"
                  v-model="perPageReqr"
                  :options="pageOptionsReqr"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </div>
        </b-row>
        <div>
          <b-modal
            :id="transActAcceptModal.id" 
            :title="transActAcceptModal.title"
            v-model="showTransActAcceptModal"
            header-bg-variant="info"
            header-text-variant="dark"
            body-bg-variant="light"
            body-text-variant="dark"
            size="lg"
            hide-footer
          >
            <b-row class="mb-1">
              <h5 class="text-info ml-3">{{$t('transport.transAcceptInfo')}} </h5> 
            </b-row>
            <b-row class="mb-1">
              <b-col cols="3">{{ $t('transport.selTruck') }}</b-col>
              <b-col>
                <v-select
                  v-model="selectedTruck"
                  :options="trucks"
                  :reduce="text => text.value"
                  label = "text"
                  :placeholder="$t('surcharge.plsSelect')"
                ></v-select>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col cols="3">{{ $t('transport.selDriver') }}</b-col>
              <b-col>
                <b-form-select
                  v-model="selectedDriver"
                  :options="drivers"
                ></b-form-select>
              </b-col>
            </b-row>
            <div class="row col-sm-12 my-2">
              <h4 class="f-w-600 mt-2 mr-5" style="font-size:16px;">{{ $t("transport.startAt") }}</h4>                    
              <div class="col-sm-3 ml-5">   
                <datepicker 
                  v-model="startDate"               
                  input-class="datepicker-here form-control digits" 
                  :disabled-dates="disabledDates"  
                  :format="format" 
                  :placeholder="$t('transport.datePh')"
                  :language="th"
                >
                </datepicker>              
              </div>
              <div class="col-sm-3">
                <b-form-timepicker 
                  v-model="startTime" 
                  reset-button
                  :label-reset-button="$t('transport.reset')"
                  :label-close-button="$t('transport.close')"
                  :label-no-time-selected="$t('transport.noTimeSelected')"
                  :placeholder= "$t('transport.timePh')" 
                  locale="th"
                >
                </b-form-timepicker>                  
              </div>
            </div>
            <div class="w-100">
              <b-button
                variant="primary"
                size="sm"
                class="float-right"
                @click="clickTransportAccept_OK"
              >
                {{ $t('truck.ok') }}
              </b-button>
            </div>
          </b-modal>
          <b-modal id="contModalReqr" :title="modalTitleReqr" ok-only @hide="resetInfoModalReqr">
            <div class="gradient-yg p-1" >
                        <div class="dashboard">
                            <div class="image-scroll-container">
                                <div class="image-scroll" ref="scrollContainer">
                                    <div
                                    class="image-item"
                                    v-for="(image, index) in imageUriModalReqr"
                                    :key="image.id"
                                    >
                                    <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                                    <span class="image-counter">{{ index + 1 }} of {{ imageUriModalReqr.length }}</span>
                                    </div>
                                    <div v-if="imageUriModalReqr.length === 0" class="no-images">
                                    {{$t('approvedTrans.noImageYet') }}
                                    </div>
                                </div>
                                <div class="scroll-controls" v-if="imageUriModalReqr.length > 1">
                                    <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                                    <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                                    <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                                    <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                                </div>
                            </div>                        
                        </div>
                    </div>
          </b-modal>
          <b-modal id="truckInfo" header-text-variant="primary" :title="$t('truck.truckInfo')" ok-only @hide="resetInfoModalTruckInfo" >
              <div class="card me-5" style=" width:30rem">
                  <div class="row ml-2 mt-2"> 
                      <h5 class="text-primary"> {{ $t('truck.licensePlate') }} :</h5> 
                      <span class="ml-3 text-info"> {{ truckInfo.licensePlate }}</span>                  
                  </div>
                  <div class="row ml-2 mt-2"> 
                      <h5 class="text-primary"> {{ $t('truck.registExpiryDate') }} :</h5> 
                      <span class="ml-3 text-info"> {{ $moment(truckInfo.registExpiryDate).format("DD-MM-YYYY") }}</span>                  
                  </div>                        
                  <div class="row ml-2 mt-2"> 
                      <h5 class="text-primary"> {{ $t('truck.insurExpiryDate') }} :</h5> 
                      <span class="ml-3 text-info"> {{ $moment(truckInfo.insurExpiryDate).format("DD-MM-YYYY") }}</span>                  
                  </div>
                  <div class="row ml-2 mt-2"> 
                      <h5 class="text-primary"> {{ $t('truck.type') }} :</h5> 
                      <span class="ml-3 text-info"> {{ truckInfo.type }}</span>                  
                  </div>
              </div>
          </b-modal>
          <b-modal id="driverInfo" header-text-variant="primary" :title="$t('driver.driverInfo')" ok-only @hide="resetInfoModalDriverInfo">
              <div class="card me-5" style=" width:30rem">
                  <div class="row ml-2 mt-2"> 
                      <h5 class="text-primary"> {{ $t('driver.name') }} :</h5> 
                      <span class="ml-3 text-info"> {{ driverInfo.name }}</span>                  
                  </div>
                  <div class=" row ml-2 mt-2"> 
                      <h5 class="text-primary"> {{ $t('company.contactPhone') }} :</h5> 
                      <span class="ml-3 text-info"> {{ driverInfo.phone }}</span>                  
                  </div>                        
                  <div class=" row ml-2 mt-2"> 
                      <h5 class="text-primary"> {{ $t('company.contactEmail') }} :</h5> 
                      <span class="ml-3 text-info"> {{ driverInfo.email }}</span>                  
                  </div>
              </div>
          </b-modal>

        </div>
    </div>
    <div class="divider"> </div>
    <div class="col-sm-6 ">
      <h2 class="mb-1 mt-4 f-w-600">{{ $t('transport.transBookingList') }}</h2>
      <b-table
        sticky-header
        head-variant="light"
        table-variant="info"
        show-empty
        sort-icon-left
        stacked="md"
        :sort-by.sync="sortByTrans"
        :sort-desc.sync="sortDescTrans"
        :items="itemsTrans"
        :fields="fieldsTrans"
        :current-page="currentPageTrans"
        :per-page="perPageTrans"
      >
      <template #cell(truckInfo)="row" >
        <b-button  size="md" @click="openModalTruckInfo(row.item, row.index, $event.target )" class="m-1">
            {{ row.item.licensePlate }}
        </b-button>
      </template>
      <template #cell(driverInfo)="row" >
        <b-button  size="md" @click="openModalDriverInfo(row.item, row.index, $event.target )" class="m-1">
            {{ row.item.driverId }}
        </b-button>
      </template>
      <template #empty>
            <h5>{{ $t('reuse.noRecord') }}</h5>
        </template>
      </b-table>
      <b-row>
        <div class="row col-sm-8 ">
          <b-col class="my-1 ml-3">
            <b-pagination
              v-model="currentPageTrans"
              :total-rows="totalRowsTrans"
              :per-page="perPageTrans"
              align="fill"
              class="my-0"
            ></b-pagination>
          </b-col>   
          <b-col sm="3" md="6" class="my-1">
            <b-form-group
              :label="$t('require.perPage')"
              label-for="per-page-select"
              label-cols-sm="6"
              label-cols-md="4"
              label-cols-lg="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0 "
            > 
              <b-form-select
                id="per-page-select"
                v-model="perPageTrans"
                :options="pageOptionsTrans"
              ></b-form-select>
            </b-form-group>
          </b-col>          
        </div>
      </b-row>
    </div>
  </b-container>
  </div>
</template>
<script>
import {matchTxsTrans, getData ,truckListAccept, driverListAccept, updateTransStatusMatchTx, getDataWithinDays,saveWithId} from "../../firebase"
import {en, th} from 'vuejs-datepicker/dist/locale'
  export default {
    data() {
      return {
        asOf : this.$moment().format( "HH:mm,  DD-MM-YYYY"),
        en: en,
        th: th,
        compId : '',
        itemsReqr: [],
        itemsTrans: [],
        showTransActAcceptModal : false,
        trucks: [],
        selectedTruck: '',
        drivers: [],
        truckInfo : '',
        driverInfo : '',
        selectedDriver: '',
        selected_mTxId : '',
        format: "yyyy-MM-dd",
        disabledDates: {
          to: new Date(),
        },
        startDate: '',
        startTime: '',
        fieldsReqr: [
          { key: 'mTxId', label: this.$t('transport.mTxId'), sortable: true, },      
          { key: 'cust', label: this.$t('transport.cust'), sortable: true,  variant: 'secondary'},            
          { key: 'distance', label: this.$t('matchTx.distance'), sortable: true, },
          { key: 'transStatus', label: this.$t('transport.transStatus'), sortable: true, variant: 'danger',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }},                      
          { key: 'actTrans', label: this.$t('matchTx.actions'), variant: 'warning' },         
          { key: 'contImageReqr', label: this.$t('matchTx.contNo'), sortable: true, variant: 'info'},          
          { key: 'agent', label: this.$t('matchTx.agent'), sortable: true,  variant: 'secondary'},               
          { key: 'detDate', label: this.$t('matchTx.detDate'), sortable: true, }, 
          { key: 'contType', label: this.$t('matchTx.contType'), sortable: true, },
          { key: 'contSize', label: this.$t('matchTx.contSize'), sortable: true, },
          { key: 'contGrade', label: this.$t('matchTx.contGrade'), sortable: true, },
          { key: 'maxGross', label: this.$t('container.maxGross'), sortable: true, },
          { key: 'tare', label: this.$t('container.tare'), sortable: true, },
          { key: 'compNameLocalRels', label: this.$t('matchTx.compNameLocalRels'), sortable: true, variant: 'success', },                
          { key: 'jobTypeRels', label: this.$t('matchTx.jobTypeRels'), sortable: true, variant: 'success',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'sRelsTS', label: this.$t('release.startRelsDate'), sortable: true, variant: 'success',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY")
          }},  
          { key: 'addressRels', label: this.$t('matchTx.address'), sortable: false,},
          //{ key: 'contRelsAddress', label: this.$t('transport.startEmptyLoc'), sortable: false, variant: 'success',},              
          { key: 'compNameLocalReqr', label: this.$t('matchTx.compNameLocalReqr'), sortable: true, variant: 'primary',},                
          { key: 'jobTypeReqr', label: this.$t('matchTx.jobTypeReqr'), sortable: true, variant: 'primary',
              formatter: value => {
                return this.$t(`matchTx.${value}`)
          }},
          { key: 'sReqrTS', label: this.$t('require.startReqrDate'), sortable: true, variant: 'primary',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY")
          }},    
          //{ key: 'contReqrAddress', label: this.$t('transport.destEmptyLoc'), sortable: false, variant: 'primary', },          
          { key: 'addressReqr', label: this.$t('matchTx.address'), sortable: false, }, 
          { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, 
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY @ HH:mm")
          }},
        ],
        fieldsTrans: [
          { key: 'transId', label: this.$t('transport.transId'), sortable: true},  
          { key: 'truckInfo', label: this.$t('truck.licensePlate'),variant: 'warning', sortable: true, }, 
          // { key: 'licensePlate', label: this.$t('truck.licensePlate'), sortable: true},                   
          // { key: 'driverId', label: this.$t('driver.driverId'), sortable: true},    
          { key: 'driverInfo', label: this.$t('driver.driverId'),variant: 'secondary', sortable: true, }, 
          { key: 'startAt', label: this.$t('transport.startAtDateTime'), sortable: true, variant: 'success',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY @ HH:mm")
          }},          
          { key: 'transStatus', label: this.$t('transport.transStatus'), sortable: true,variant: 'success',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, 
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY @ HH:mm")
          }},
        ],
        totalRowsReqr: 1,
        currentPageReqr: 1,
        perPageReqr: 10,
        pageOptionsReqr: [5, 10, 15, { value: 100, text: "Show a lot" }],
        sortByReqr: 'timestamp',
        sortDescReqr: true,
        transActAcceptModal: {
          id: 'transportActAccept-modal',
          title: this.$t('transport.transAccept'),
        },
        totalRowsTrans: 1,
        currentPageTrans: 1,
        perPageTrans: 10,
        pageOptionsTrans: [5, 10, 15, { value: 100, text: "Show a lot" }],
        sortByTrans: 'timestamp',
        sortDescTrans: true,
        imageUriModalReqr: [],
        modalTitleReqr : '',
      }
    },
    mounted() {
      this.compId= localStorage.getItem("compId")
      matchTxsTrans(this.compId , (res)=>{
        this.itemsReqr = res
        this.totalRowsReqr = res.length
      })
      getDataWithinDays( "Transport", 'compId', this.compId, 30,(res)=>{
          this.itemsTrans = res
          this.totalRowsTrans= res.length
        })
    },
    methods: {
      actTransReject(item) {
        this.$bvModal.msgBoxConfirm(this.$t('transport.confirmRejectMsg'), {
          title: this.$t('matchTx.plsConfirm'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'warning',
          okTitle: this.$t('matchTx.yes'),
          cancelTitle: this.$t('matchTx.no'),
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(async(value) => {
            if (value) {
              this.selected_mTxId = item.mTxId
              let payload = {
                transId: this.selected_mTxId,
                licensePlate: '',
                driverId : '',
                // driverName: '',
                compId: this.compId,   
                transStatus : 'reject',
                transStatus1 : '',
                transStatus2 : '',
                startAt : null,
                timestamp: new Date().valueOf(),                     
              }
              await saveWithId('Transport', this.selected_mTxId, payload).then(async()=>{
                await updateTransStatusMatchTx(this.selected_mTxId, 'reject').then(async()=>{
                  await this.refresh()
                  this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'error' , duration: 5000});                         
                })                        
              })  
            } else {
              return
            }
          })
          .catch(error => {
            this.$toasted.show( `Action-Reject-Require : ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
          })
      },      
      async actTransAccept(item) {
        this.selected_mTxId = item.mTxId
        await truckListAccept(this.compId, async(res1)=>{
          this.trucks = res1
          await driverListAccept(this.compId, (res2)=>{
            this.drivers = res2
          })
        }).then(()=>{
          this.showTransActAcceptModal = true
        })
      },
      async clickTransportAccept_OK() {
        let msg = 'completed'
        if (this.selectedTruck ==='') {
            msg = 'transport.addSelectedTruck'
        } else if (this.selectedDriver ===''){
            msg = 'transport.addSelectedDriver'
        } else if (this.startDate ===''){
          msg = 'transport.addStartDate'
        } else if (this.startTime ===''){
          msg = 'transport.addStartTime'
        }  
        if (msg === 'completed'){
          // console.log( `Date Time => ${this.$moment(this.startDate).format("YYYY-MM-DD")} ${this.startTime}`)

          let payload = {
            transId: this.selected_mTxId,
            licensePlate: this.selectedTruck,
            driverId : this.selectedDriver,
            compId: this.compId,   
            transStatus : 'accept',
            transStatus1 : 'accept',
            transStatus2 : 'accept',
            startAt : Date.parse(`${this.$moment(this.startDate).format("YYYY-MM-DD")} ${this.startTime}`),
            timestamp: new Date().valueOf(),                     
          }
          await saveWithId('Transport', this.selected_mTxId, payload).then(async()=>{
            await updateTransStatusMatchTx( this.selected_mTxId, 'accept').then(async()=>{
              await this.refresh()
              this.showTransActAcceptModal = false
              this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                         
            })                        
          })  
        }else{
          this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
        }
      },
      // async clickTransportReject_OK() {
      //   let payload = {
      //     transId: this.selected_mTxId,
      //     licensePlate: '',
      //     driverId : '',
      //     compId: this.compId,   
      //     transStatus : 'reject',
      //     transStatus1 : '',
      //     transStatus2 : '',
      //     timestamp: new Date().valueOf(),                 
      //   }
      //   await saveWithId('Transport', this.selected_mTxId, payload).then(async()=>{
      //     await updateTransStatusMatchTx( this.selected_mTxId, 'reject').then(async()=>{
      //       await this.refresh()
      //       this.showTransActAcceptModal = false
      //       this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'error' , duration: 5000});          
      //     })                                 
      //   })  
      // },
      async openModalImageReqr(item, index, button) {
        await getData( 'Container' , 'contId' , item.contId, (res)=>{
            this.imageUriModalReqr = res[0].url6
            this.modalTitleReqr = res[0].contNo
            this.$root.$emit('bv::show::modal', "contModalReqr" , button)
        })
      },
      resetInfoModalReqr() {
        this.modalTitleReqr = ''
        this.imageUriModalReqr = []
      },
      async openModalTruckInfo(item, index, button) {
            await getData('Truck', 'licensePlate',item.licensePlate , (res)=>{
            this.truckInfo = res[0]
            })
            this.$root.$emit('bv::show::modal', "truckInfo" , button)
        },
      resetInfoModalTruckInfo() {
          this.truckInfo = ''
      },  
      async openModalDriverInfo(item, index, button) {
            await getData('Users', 'userId',item.driverId , (res)=>{
            this.driverInfo = res[0]
            })
            this.$root.$emit('bv::show::modal', "driverInfo" , button)
        },
      resetInfoModalDriverInfo() {
          this.driverInfo = ''
      },  
      async refresh() {
        await matchTxsTrans(this.compId , (res)=>{
          this.itemsReqr = res
          this.totalRowsReqr = res.length
        })
        await getDataWithinDays( "Transport", 'compId' ,this.compId , 14,(res)=>{
          this.itemsTrans = res
          this.totalRowsTrans= res.length
        })
        this.selectedTruck = ''
        this.selectedDriver = ''
        this.trucks = []
        this.drivers = []
        this.selected_mTxId = ''
        this.startDate = ''
        this.startTime = ''
        this.asOf = this.$moment().format( "HH:mm,  DD-MM-YYYY")
      },
      scrollLeft() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },  
        scrollLeftS1() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        }, 
        scrollRight() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },
        scrollRightS1() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        },
    }
  }
</script>
<style scoped>
.divider {
  height: 1px;
  background-color: #0f0f0f;
  margin:5px
}

.gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
 .dashboard {
  padding: 10px;
  max-width: 100%;
  overflow-x: hidden;
}
.image-scroll-container {
  position: relative;
  margin: 20px 0;
}

.image-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  width: 100%;
}

.image-scroll::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome/Safari */
}

.image-item {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
}
.display-image {
width: 100%;
  height: 400px;
  object-fit: contain;
  border-radius: 8px;
  background-color: #f5f5f5;
  }
  .image-counter {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 14px;
}

.no-images {
  text-align: center;
  width: 100%;
  padding: 50px 0;
  color: #666;
  font-style: italic;
  font-size: 16px;
}

.scroll-controls {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.scroll-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 15px;
  margin: 0 5px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}
</style>